module.exports = __webpack_public_path__ + "static/media/banner.883f3fe1.svg";